export const firebaseConfig = {
    apiKey: "AIzaSyCmR9EvVfFTuqWgpAKhs1GYkIfyhoJNztg",
    authDomain: "reuapp-ff2b1.firebaseapp.com",
    databaseURL: "https://reuapp-ff2b1.firebaseio.com",
    projectId: "reuapp-ff2b1",
    storageBucket: "reuapp-ff2b1.appspot.com",
    messagingSenderId: "985295138425",
    appId: "1:985295138425:web:4511e5ca2bf6abb370aea8",
    measurementId: "G-8JWC5X58Y4"
}